module.exports = __webpack_public_path__ + "static/media/ieee_black.86956197.png";